module.exports = __webpack_public_path__ + "static/media/arrow-down-gray.27af813d.svg";